import SettingsDropdown from '@/components/component/Reuse/SettingsDropdown/SettingsDropdown.vue';
import { getImageUrl, message, loader } from '@/libs/helper';
import pageRoutes from '@/libs/constant/pageRoutes'
import { getIamgUserGroupsList, deleteUserGroup } from '@/libs/api/api';
import constants from '@/libs/constant/constants';
import TableFilters from '@/components/component/Reuse/TableFilters/TableFilters.vue'
import { cloneDeep, isEmpty } from 'lodash';
import BulkUpdate from './BulkUpload/BulkUpdate.vue'

export default {
    name: 'IamuserGroup',
    data() {
        return {
            isEmpty,
            currentOrganisationID: null,
            setsList: [],
            tableDataCount: null,
            columns: ['group_checkbox_all', 'group_name', 'group_members', 'group_permissions', 'settings'],
            tableSettings: {
                headings: {
                    group_checkbox_all: 'group_checkbox_all',
                    group_name: 'group Name',
                    group_members: 'Group Members',
                    group_permissions: ' Group Permissions',
                    settings: ''
                },
                pagination: { show: true, edge: true },
                perPage: '25',
                filterable: [],
                filterByColumn: true,
                sortable: ['yes'],
                alwaysShowPerPageSelect: false,
                perPageValues: []
            },
            settingOptions: [
                { command: 'EDIT_GROUP', label: 'Edit' },
                { command: 'DELETE_GROUP', label: 'Remove', isDelete: true }
            ],
            getImageUrl,
            limit: 50,
            currentPage: 1,
            skip: 0,
            previousPage: 1,
            sort: 'group_name',
            order: 'asc',
            selected: 10,
            selectedEntries: [],
            searchValue: '',
            isAllMarked: false,
            loadingTableData: false,
            selectedTableFilters: {},
            category: '',
            tableFilters: {},
            pageSize: '10',
            isBulkEdit: false,
            organisation: ''
        }
    },
    computed: {
        perPageSelect: {
            get() {
                return this.pageSize
            },
            async set(val) {
                this.pageSize = val
                this.skip = 0
                this.currentPage = 1
                let orgID = this.currentOrganisation && this.currentOrganisation._id
                await this.fetchGroupList(orgID)
            }
        }
    },
    props: {
        allOrgnisations: Array,
        currentOrganisation: Object,
    },
    components: {
        SettingsDropdown,
        TableFilters,
        BulkUpdate
    },
    watch: {
        totaltableData(value) {
            this.totalPage = value
        },
        currentPage(value) {
            this.current = value
        },
        selectedValue(value) {
            this.selected = value || this.perPage
        },
        tableData(value) {
            this.rowsData = value
        },
        selectedTableFilters(value) {
            this.tableFilters = value
        }
    },
    beforeCreate() {

    },
    created() {
        // this.tableDataCount= this.setsList && this.setsList.length
    },
    async mounted() {
        //call api to get user groups list
        let orgID = this.currentOrganisation && this.currentOrganisation._id
        this.organisation = orgID
        await this.fetchGroupList(orgID)
    },
    methods: {
        async fetchGroupList(id) {
            loader(this, true)
            let params = `?skip=${this.skip}&limit=${this.pageSize}&sort=${this.sort}&order=${this.order}`
            // let params=``
            let body = { searchText: this.searchValue }
            await getIamgUserGroupsList(id, params, body).then((response) => {
                let data = response && response.result
                this.tableDataCount = response && response.result && response.result.total_count;
                this.setsList = data.items
                // message(this, constants.messageType.SUCCESS, ('Group details fetched'))
                loader(this, false)
            }).catch((error) => {
                message(this, constants.messageType.ERROR, (error))
                loader(this, false)
            })
        },
        gotoCreateUserGroup() {
            this.$router.push({ name: pageRoutes.iamCreateGroup, params: { id: this.currentOrganisation && this.currentOrganisation._id } })
        },
        async changePage(currentPage) {
            // this.$refs.setsTable.setPage(currentPage)
            this.previousPage = this.currentPage
            this.currentPage = currentPage
            // this.skip = (currentPage - 1) * this.selectedValue
            this.skip = (currentPage - 1) * this.pageSize
            // call api and and set updated data
            let orgID = this.currentOrganisation && this.currentOrganisation._id
            await this.fetchGroupList(orgID)

        },
        handleCheckBoxSelect(row) {
            let id = row._id
            if (!this.selectedEntries.includes(id)) {
                this.selectedEntries.push(id)
            } else {
                const index = this.selectedEntries.indexOf(id)
                if (index > -1) {
                    this.selectedEntries.splice(index, 1);
                }
            }

        },
        async querySearch(query, cb) {
            // trying api call
            if (query === undefined || query === '' || query.length < 2) {
                return
            }
            let searchResult = []
            try {
                let body = { searchText: query }
                let params = `?skip=${0}&limit=${this.pageSize}&sort=${this.sort}&order=${this.order}`
                let id = this.currentOrganisation && this.currentOrganisation._id
                searchResult = await getIamgUserGroupsList(id, params, body)
                this.tableDataCount = searchResult && searchResult.result.total_count;
                this.setsList = searchResult.result.items
            } catch (error) {
                console.log("error", error)
                return error

            }
            // call callback function to return suggestion objects
            cb(searchResult.result.items);
        },
        toggleAll(event) {
            // if (!this.showBulkUpdate) return
            this.selectedEntries = []
            this.allMarked = event
            this.selectedEntries = this.allMarked ? this.$refs.setsTable.data.map(row => row._id) : []
            let length = this.selectedEntries && this.selectedEntries.length;
            if (length) {
                this.selectedEntries = this.selectedEntries.filter((item, index) => {
                    if (index < this.selected) return item
                })
            }
        },
        changeSort(sortingKey) {
            this.sortingOrder = this.sortingKey !== sortingKey ? 'desc' : this.sortingOrder === 'desc' ? 'asc' : 'desc'
            this.sortingKey = sortingKey
            this.sorting(this.category, this.sortingOrder, this.sortingKey)
        },
        sorting(type, order, sort) {
            this.skip = 0
            this.order = order
            this.currentPage = 1
            this.sort = sort
            this.fetchNewRecord(this.skip, this.pageSize, this.sort, this.order)
        },
        fetchNewRecord: async function (skip, limit, sort, order) {
            //call api and set data to table
            let params = `?skip=${skip}&limit=${limit}&sort=${sort}&order=${order}`
            let orgID = this.currentOrganisation && this.currentOrganisation._id
            loader(this, true)
            let body = { searchText: this.searchValue }
            await getIamgUserGroupsList(orgID, params, body).then((response) => {
                if (response && response.result) {
                    this.setsList = response.result.items
                    this.tabelDataCount = response.result.total_count
                }
                loader(this, false)
            }).catch((error) => {
                message(this, constants.messageType.ERROR, (error))
                loader(this, false)
            })
        },
        setTableFilters(filters) {
            // console.log('setTableFilters', filters)
            this.selectedTableFilters = cloneDeep(filters)
            this.$store.dispatch('setTableFilters', filters)
            this.filterCall()
        },
        filterCall() {
            this.changePage(1)
        },
        applyFilters() {
            /*  let filtersToApply = {}
             if (!isEmpty(this.selectedTableFilters)) {
                 if (this.selectedTableFilters.city && this.selectedTableFilters.city.length > 0) {
                     filtersToApply.city = this.selectedTableFilters.city
                 }
                 if (this.selectedTableFilters.name && this.selectedTableFilters.name.length > 0) {
                     filtersToApply.name = this.selectedTableFilters.name
                 }
             } 
             this.selectedTableFilters = filtersToApply
             return this.selectedTableFilters */
        },
        async clearSearchInput() {
            this.searchValue = ''
            let orgID = this.currentOrganisation && this.currentOrganisation._id
            this.skip = 0
            this.currentPage = 1
            await this.fetchGroupList(orgID)
        },
        handleSearchChange(val) {
            console.log("val", val)
        },
        trimName(str) {
            return str.substr(0, 19)
        },
        handleCommand(command, data) {
            switch (command) {
                case 'EDIT_GROUP':
                    this.editGroup(data)
                    break
                case 'DELETE_GROUP':
                    this.deleteGroup(data)
                    break
            }
        },
        async deleteGroup(group) {
            let id = group && group.row && group.row._id
            let orgID = this.currentOrganisation && this.currentOrganisation._id
            // call api of delete 
            loader(this, true)
            await deleteUserGroup(id).then(async (res) => {
                message(this, constants.messageType.SUCCESS, (res.message))
                await this.fetchGroupList(orgID);
                loader(this, false)
            }).catch((error) => {
                message(this, constants.messageType.ERROR, (error))
                loader(this, false)
            })
        },
        editGroup(group) {
            let id = group && group.row && group.row._id
            this.$router.push({ path: `iam-create-group/edit/${id}` })
        },
        bulkEdit() {
            this.isBulkEdit = true
        },
        testButton() {
            this.selectedEntries = []
            this.isBulkEdit = false
            this.toggleAll(false)
            this.clearSearchInput()
        },
        refreshPage() {
            this.clearSearchInput()
        },
    }
}